import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { trackEvent } from "../lib/analytics";

const NAV = [
  { id: "verhaal", label: "Het verhaal" },
  { id: "galerij", label: "Galerij" },
  { id: "plattegrond", label: "Plattegrond" },
  { id: "kenmerken", label: "Kenmerken" },
  { id: "ligging", label: "Ligging" },
  { id: "makelaar", label: "Makelaar" }
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-brand-bg/85 backdrop-blur-xl border-b border-brand-border"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-[1600px] items-center justify-between px-6 py-5 md:px-12 lg:px-20">
        <a
          href="#top"
          data-testid="logo-link"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className={`flex flex-col leading-none transition-colors ${
            scrolled ? "text-brand-ink" : "text-white"
          }`}
        >
          <span className="font-serif text-2xl tracking-tight">Kempenaar 29</span>
          <span className="overline mt-1 text-[10px]" style={{ color: scrolled ? "#4A5D4E" : "rgba(255,255,255,0.7)" }}>
            Wijk bij Duurstede
          </span>
        </a>

        <nav className="hidden items-center gap-8 lg:flex">
          {NAV.map((item) => (
            <button
              key={item.id}
              data-testid={`nav-${item.id}`}
              onClick={() => handleClick(item.id)}
              className={`text-sm font-medium tracking-wide transition-opacity hover:opacity-60 ${
                scrolled ? "text-brand-ink" : "text-white"
              }`}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="header-cta-bezichtiging"
          onClick={() => { trackEvent("cta_click", { location: "header", action: "viewing_request" }); handleClick("contact"); }}
          className={`hidden items-center gap-2 px-6 py-3 text-sm font-medium transition-all lg:inline-flex ${
            scrolled
              ? "bg-brand-moss text-white hover:bg-brand-mossDark"
              : "border border-white text-white hover:bg-white hover:text-brand-ink"
          }`}
        >
          Plan bezichtiging
        </button>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className={`lg:hidden ${scrolled ? "text-brand-ink" : "text-white"}`}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-brand-bg border-t border-brand-border">
          <div className="mx-auto flex max-w-[1600px] flex-col px-6 py-6">
            {NAV.map((item) => (
              <button
                key={item.id}
                data-testid={`mobile-nav-${item.id}`}
                onClick={() => handleClick(item.id)}
                className="border-b border-brand-border py-4 text-left font-serif text-2xl text-brand-ink"
              >
                {item.label}
              </button>
            ))}
            <button
              data-testid="mobile-cta-bezichtiging"
              onClick={() => { trackEvent("cta_click", { location: "mobile_menu", action: "viewing_request" }); handleClick("contact"); }}
              className="mt-6 bg-brand-moss px-6 py-4 text-sm font-medium text-white"
            >
              Plan bezichtiging
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
